import React, { useState } from 'react';
import styled from 'styled-components';
import UsersList from '../users/UsersList';
import UserForm from '../users/UserForm';
import { User } from '../../types/user';

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const SectionTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: ${({ theme }) => theme.colors.text};
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.textLight};
  line-height: 1.6;
  margin: 0 0 1.5rem 0;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  
  @media (max-width: 768px) {
    max-width: 95%;
    padding: 1.5rem;
  }
`;

const UsersTab: React.FC = () => {
  const [showUserForm, setShowUserForm] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | undefined>(undefined);
  
  const handleAddUser = () => {
    setSelectedUser(undefined);
    setShowUserForm(true);
  };
  
  const handleEditUser = (user: User) => {
    setSelectedUser(user);
    setShowUserForm(true);
  };
  
  const handleCloseForm = () => {
    setShowUserForm(false);
    setSelectedUser(undefined);
  };
  
  const handleFormSuccess = () => {
    handleCloseForm();
  };
  
  return (
    <Container>
      <SectionTitle>Gestion des utilisateurs</SectionTitle>
      
      <Description>
        Gérez les membres de votre agence : ajoutez de nouveaux utilisateurs, 
        modifiez leurs informations ou supprimez des comptes.
      </Description>
      
      <UsersList 
        onAddUser={handleAddUser}
        onEditUser={handleEditUser}
      />
      
      {showUserForm && (
        <ModalOverlay onClick={handleCloseForm}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <UserForm 
              user={selectedUser}
              onCancel={handleCloseForm}
              onSuccess={handleFormSuccess}
            />
          </ModalContent>
        </ModalOverlay>
      )}
    </Container>
  );
};

export default UsersTab;
